import { AppButton } from ".";
import type { ButtonProps } from "@mui/material";

export default function JoinMeetingButton({
  sx = {},
  url,
  fullWidth = false,
  size = "medium",
}: {
  sx?: object;
  url: string;
  fullWidth?: boolean;
  size?: ButtonProps["size"];
}) {
  const onJoinMeetingClick = () => {
    window.open(url, "_blank");
  };

  return (
    <AppButton
      size={size}
      onClick={onJoinMeetingClick}
      fullWidth={fullWidth}
      sx={{ ...sx }}
    >
      Join meeting
    </AppButton>
  );
}
